export default "__VITE_ASSET__CnEsAwNa__"